import ColorPicker from './ColorPicker';
export default ColorPicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-colorpicker/src/index.js